import { ButtonBase, styled as muiStyled } from '@mui/material'

export const AddIntervalPopoverContainer = muiStyled('div')(
  ({ theme }) => `
    display: flex;
    flex-direction: column;
    gap: 10px;
    align-items:center;
`,
)

export const AddIntervalButton = muiStyled(ButtonBase)(
  ({ theme }) => `
    background: #ebebeb;
    color: black;
    padding: 6px 18px;
    border-radius: 5px;
    transition: 300ms all ${theme.transitions.easing.quickInOut};
    &:disabled {
    background: #dcdcdc33;
    color: #797979;
    }
    &:hover {
        background: #dcdcdc;
    }
`,
)
